// utils/verification.js

/**
 * Send verification code to a phone number
 * @param {string} phoneNumber - Phone number in international format (e.g., 254712345678)
 * @param {string} code - Verification code to send
 * @returns {Promise} Response data from the API
 */
export const sendVerificationCode = async (phoneNumber, code) => {
    try {
        const response = await useFetch('/api/send-verification', {
            method: 'POST',
            body: {
                phoneNumber,
                code
            }
        });
        console.log(response)
        if (response.error.value) {
            throw new Error(response.error.value?.message || 'Failed to send verification code');
        }
        console.log(response.data.value)
        return response.data.value;
    } catch (error) {
        console.error('Failed to send verification code:', error);
        throw error;
    }
};
